export default __webpack_public_path__ + "static/media/group-582@2x.c6d6b58f.png";